<template>
<div>
  <canvas class="social-filter" ref="social-filter" width="1200" height="630" />
  <canvas class="effect-filter" ref="effect-filter" width="1000" height="1000" />
  <canvas class="small-photo" ref="small-photo" width="192" height="192" />
</div>
</template>

<script>
import * as PhotoStore from '@/components/DOM/PhotoStore/PhotoStore.js'
// import * as Server from '@/components/DOM/Server/Server.js'

export default {
  data () {
    return {
      // Server,
      PhotoStore
    }
  },
  async mounted () {
    let chosenPhoto = PhotoStore.state.imageURL
    let chosenRadiance = PhotoStore.state.chosenRadiance
    let redirect = () => {
      this.$emit('home')
    }
    if (!chosenPhoto) {
      redirect()
      return
    }
    if (!chosenRadiance) {
      redirect()
      return
    }

    await this.draw()
    await this.makeFBPost()
    this.makeSmall()

    let effectFilter = this.$refs['effect-filter']
    let socialFilter = this.$refs['social-filter']
    let smallPhoto = this.$refs['small-photo']

    let effectURL = effectFilter.toDataURL()
    let socialURL = socialFilter.toDataURL()
    let smallURL = smallPhoto.toDataURL()

    effectFilter.addEventListener('click', () => {
      let data = effectURL
      let href = document.createElement('a')
      href.href = data
      href.target = '_blank'
      href.download = 'radianceis.png'
      href.click()
    }, false)

    this.$emit('small', smallURL)
    this.$emit('avatar', effectURL)
    this.$emit('social', socialURL)
    this.$emit('upload', {
      avatar: effectURL,
      social: socialURL,
      small: smallURL
    })
  },
  methods: {
    async makeSmall () {
      let bigPhoto = this.$refs['effect-filter']
      let canvas = this.$refs['small-photo']
      var ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      ctx.drawImage(bigPhoto, 0, 0, canvas.width, canvas.height)
    },
    async makeFBPost () {
      // function drawRadianceIs ({ ctx, radiance, flip }) {
      //   ctx.textAlign = 'center'
      //   ctx.textBaseline = 'center'
      //   ctx.fillStyle = 'white'
      //   ctx.font = `60px CronosPro-LtDisp, PingFang-SC-Regular`
      //   ctx.fillText('#radianceis', 250 - 8, 500 - 120)
      //   ctx.font = `30px CronosPro-LtDisp, PingFang-SC-Regular`
      //   ctx.fillText(radiance, 250 - 8, 500 - 85)
      // }

      var canvas = this.$refs['social-filter']
      var ctx = canvas.getContext('2d')

      ctx.clearRect(0, 0, canvas.width, canvas.height)

      // ctx.fillStyle = '#020017'
      // ctx.fillRect(0, 0, 1200, 630)

      // ctx.lineWidth = '8'
      // ctx.strokeStyle = '#CEBC9E'
      // ctx.strokeRect(0, 0, canvas.width, canvas.height)

      // ctx.textBaseline = 'center'
      // ctx.fillStyle = 'white'
      // ctx.shadowColor = 'white'
      // ctx.shadowBlur = 20
      // ctx.shadowOffsetX = 0
      // ctx.shadowOffsetY = 0

      // let xpad = (630 - 500) / 2
      // let maringTop = 30

      // ctx.textAlign = 'center'
      // ctx.font = `80px CronosPro-LtDisp, PingFang-SC-Regular`
      // ctx.fillText('#RadianceIs', xpad + 250, maringTop + 250)

      // ctx.textAlign = 'center'
      // ctx.font = `50px CronosPro-LtDisp, PingFang-SC-Regular`
      // ctx.fillText('傳承閃耀', xpad + 250, maringTop + 340)

      // ctx.shadowBlur = 0
      var framer = () => {
        return new Promise((resolve, reject) => {
          var frame = new Image()
          frame.onload = () => {
            // frame base
            ctx.drawImage(frame, 0, 0, canvas.width, canvas.height)

            // avatar
            let x1 = 1200 - 490
            let y1 = (630 - 490) / 2
            x1 = x1 - y1
            ctx.drawImage(this.$refs['effect-filter'], x1, y1, 490, 490)

            resolve()
          }
          frame.src = require('./img/fbshareimage.png')
        })
      }

      await framer()
    },
    async draw () {
      var drawContent = ({ ctx, url }) => {
        return new Promise((resolve, reject) => {
          var img = new Image()
          img.onload = () => {
            let edge = 8 * 2 - 1
            ctx.drawImage(img, edge, edge, 1000 - edge * 2, 1000 - edge * 2)
            resolve()
          }
          img.src = url
        })
      }
      var drawFrame = ({ ctx, url }) => {
        return new Promise((resolve, reject) => {
          var img = new Image()
          img.onload = () => {
            let edge = 0
            ctx.drawImage(img, edge, edge, 1000 - edge * 2, 1000 - edge * 2)
            resolve()
          }
          img.src = url
        })
      }
      function drawRadianceIs ({ ctx, radiance, flip }) {
        ctx.textAlign = 'center'
        ctx.textBaseline = 'center'
        ctx.fillStyle = 'white'
        if (!flip) {
          ctx.font = `120px CronosPro-LtDisp, PingFang-SC-Regular`
          ctx.fillText('#radianceis', 500 - 8, 1000 - 120 * 2)
          ctx.font = `60px CronosPro-LtDisp, PingFang-SC-Regular`
          ctx.fillText(radiance, 500 - 8, 1000 - 85 * 2)
        } else {
          ctx.font = `120px CronosPro-LtDisp, PingFang-SC-Regular`
          ctx.fillText('#radianceis', 500 - 8, 1000 - 95 * 2)
        }
      }

      var canvas = this.$refs['effect-filter']
      var ctx = canvas.getContext('2d')

      ctx.clearRect(0, 0, canvas.width, canvas.height)
      let chosenPhoto = PhotoStore.state.imageURL
      let chosenRadiance = PhotoStore.state.chosenRadiance
      console.log(chosenRadiance)

      await drawContent({ ctx, url: chosenPhoto })
      await drawContent({ ctx, url: require('./img/filter.png') })
      await drawFrame({ ctx, url: require('./img/frame.png') })

      drawRadianceIs({ ctx, radiance: chosenRadiance.name, flip: chosenRadiance.number === '06' })
    }
  }
}
</script>


<style scoped>
.effect-filter{
  width: 100%;
  cursor: pointer;
}
.social-filter{
  /* width: 100%; */
  display: none;
}
.small-photo{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/DOM/EffectFilter/EffectFilter.vue